export default "__VITE_ASSET__BlOBhDLl__"